import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45access_45global from "/app/middleware/check-access.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  check_45access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "is-admin": () => import("/app/middleware/isAdmin.ts"),
  "is-user": () => import("/app/middleware/isUser.ts"),
  "sanctum:auth": () => import("/app/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/app/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}